/**
 * Gets organisation permissions of member and updates state
 * @updated 04/11/2024
 * @public
 * @param ctx StateContext<MeStateModel>
 * @param userId string
 * @param organisationId string
 * @see libs/app/client/shared/states/src/lib/me/states/me.state.ts
 */ export class GetOrganisationPermissions {
  public static readonly type = '[Me] GetOrganisationPermissions';
  constructor(
    public readonly userId: string,
    public readonly organisationId: string,
    public readonly meta?: boolean,
  ) {}
}
